import type { FaireProductEntity } from "../../entity_types/product";

export const p_upm9ppsr82: FaireProductEntity = {
  token: "p_upm9ppsr82",
  type: "product",
  name: "Green Bunny Cat Bowl, Anti-Tip Ceramic Pet Feeder_CWMM5931",
  brandToken: "b_g84ckd3mt5",
  brandName: "PAWPAWwholesale",
  imageUrl:
    "https://cdn.faire.com/fastly/990db1822932be3a73c9ec2a2fd4138046b886b1e1156901dae8822f6385052d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/56ce258915ccdc7c2e2fbb9c873a11bc188951e10ab318ecd6981139318b2574.jpeg",
    "https://cdn.faire.com/fastly/ba7997b10c6a6d4202a89410ce764421fd7c597e01afcb368d4f17b19079d990.jpeg",
    "https://cdn.faire.com/fastly/64131f58905dc8512ba57dca90bbec8a96263429779bb5de918d7ba7fd41ef1e.jpeg",
    "https://cdn.faire.com/fastly/54afb59fc5d6ebd8123e179e3bb174ab668bdaf09b30e71bcc3d489b4579749a.jpeg",
    "https://cdn.faire.com/fastly/5bc3d591d12d3ec65c16f7432adad268289f6db7611c4e6a37209c4fdc295e1e.jpeg",
    "https://cdn.faire.com/fastly/b604154fd0103a5f285a508e9bd838127c27b0cfedff73e0818c43c6516c35c1.jpeg",
    "https://cdn.faire.com/fastly/3110e80f8246e069ac8ad5bf4beb0eb37e42d59f22536078e045e021e2d3be67.jpeg",
    "https://cdn.faire.com/fastly/d5a58bc66a94116b734228b99a61cd61c910908483935fe69ef0b190b4f32eb7.jpeg",
    "https://cdn.faire.com/fastly/e739411e84e75d35171c441fe3e495571f9cbb01cbef7ab3f74991b5ccaf9b53.jpeg",
    "https://cdn.faire.com/fastly/5ac20c7095b80fc74b600e1bc17f6a3438a2a8ce51509cf21087f3b8dc4d2f9a.jpeg",
    "https://cdn.faire.com/fastly/41f4e4877c8e8c80765478e8da724237fb5c03d2c1a025487292396b232112ec.jpeg",
    "https://cdn.faire.com/fastly/cf202f82c42e628eecec9d86175aa50960d21fbbbe9995951c780f40e93c978f.jpeg",
    "https://cdn.faire.com/fastly/6b599b0c69c123bca8aceb77708be4ff9678920d29097c5a2661014014f43df0.jpeg",
    "https://cdn.faire.com/fastly/e0354bbbac20acf44f8c09cca58342dbf5d7650ae399d21a8a90b1f15703d208.jpeg",
    "https://cdn.faire.com/fastly/9a92bb3286d6512d9bcd41b58c736feac33891c0fcb70a42fde1951258a02e06.jpeg",
    "https://cdn.faire.com/fastly/c2145f78b84ffe4bb2a52b77e8e2b1c9436c1c6f9a5c9232a173e6546325e745.jpeg",
  ],
  priceDollars: 20.61,
  description:
    "-Product Type: Ceramic Pet Bowl\n-Material: 100%Ceramic\n-Size: See picture\n\nTypes of products that will be on the shelves during this period:\nPet bowl,Dog bowl,Cat bowl,Pet feeder,Food bowl,Water bowl,Drinking bowl,Food and water set,Non-slip base,Non-skid bottom,Elevated dog bowl,Raised pet feeder,Slow feeder bowl,Anti-choke design,Spill-proof, Splash-proof water bowl,Collapsible bowl,Travel dog bowl,Double bowl set,Dual bowl,Automatic pet feeder,Self-watering bowl,Gravity waterer,Stainless steel pet bowl,Ceramic dog bowl / Handmade ceramic bowl,BPA-free plastic bowl,Silicone collapsible bowl,Bamboo pet feeder,Wood stand,Eco-friendly,Sustainable materials,Minimalist pet bowl,Modern dog bowl,Cute cat bowl,Personalized pet bowl, Custom name bowl,Pastel color pet dish,Wooden stand pet bowl,Boho pet bowl,Small dog bowl / For puppies,Large dog bowl / For big dogs,For cats,For kittens,Fits Frenchie,Pug,Golden Retriever,XL dog bowl,Deep bowl for large breeds,Travel pet bowl,On-the-go.",
  tags: [],
  msrpDollars: 41.21,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:07:49.004Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
